import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StepperContainerComponent } from 'app/shared/stepper/stepper-container/stepper-container.component';

@Component({
  selector: 'app-new-permit-stepper',
  templateUrl: './new-permit-stepper.component.html',
  styleUrls: ['./new-permit-stepper.component.scss']
})
export class NewPermitStepperComponent implements OnInit {
  @Input() isVehicleInProgress: string = 'true';
  @Input() isDepotsInProgress: string = 'true';
  @Input() isDriverInProgress: string = 'true';
  @Input() isVehiclesInProgress: string = 'true';
  carrierId:any;
  @ViewChild(StepperContainerComponent) StepperContainer;
  dataCntrl: any = { carrierID: -1, permittypeSelected: false, selectedtype: '', disableTypes: false, processStarted: false, currentTab: '', formValid: false, isViewEditControl: false, carrier: {}, application: {}, permit: {}, permittype: {}, vehicles: [], permitTypesDocLinks: [] };

  constructor(private activeRoute: ActivatedRoute) { }

  ngOnInit(): void {
  }
  goNext(){
    this.StepperContainer.activeStepper.isProgress = 'false';
    this.StepperContainer.next();
  }
  prevStep(){
    this.StepperContainer.previous();
  }
}
